import React, { Component } from 'react';
import withFetch from '../../hoc/withFetch';
import withAuthProvider from '../../hoc/withAuthProvider';
import { REACT_APP_API_BASE} from '../../config';
import classNames from 'classnames';
import Takeover from '../takeover';
import Success from '../spinner/success';
import SpinnerDots from '../spinner/dots';
import { Select } from '../forms';

class EditTakeover extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading:false,
            isUpdated: false, 
            editModalIsOpen: false,
            isFinished: false,
            isCopied: false,
            isSelectScenario: false,
            copyToScenarioId: null,
            copyId: null,
            view: 'start',
            districtName: this.props.districtName,
            districtUrl: `${props.listUrl}/${this.props.scenarioId}`
        };
    }
    
    async getTokenHeaders() {
        const token = await this.props.getAccessToken();
        const headers = new Headers();
        const bearer = `Bearer ${token}`;
        headers.append('Authorization', bearer);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');

        return headers;
    }

    async copyDistrict(id) {
        this.setState({
            isLoading: true
        });

        const headers = await this.getTokenHeaders();
        const rawResponse = await fetch(`${REACT_APP_API_BASE}/salesdistrict/copy/${id}/toscenario/${this.props.scenarioId}`, {
            method: 'POST',
            headers: headers
        });

        if (rawResponse.ok) {
            const result = await rawResponse.json();
            this.setState({
                isLoading: false,
                isUpdated: true,
                isCopied: true,
                view: 'start',
                copyId: result.id
            }, () => {
                if (this.props.onUpdate) {
                    this.props.onUpdate();
                }
                setTimeout(() => {
                    this.setState({
                        isFinished: true
                    });
                }, 50);
            });
        } else {
            this.setState({
                isLoading: false
            });
        }
    }

    async deactivateDistrict(id, active) {
        this.setState({
            isLoading: true
        });

        const headers = await this.getTokenHeaders();

        const rawResponse = await fetch(`${REACT_APP_API_BASE}/salesdistrict/activate/${id}/${active}`, {
            method: 'PATCH',
            headers: headers
        });

        if (rawResponse.ok) {
            await rawResponse.json();
            
            this.setState({
                isLoading: false,
                isUpdated: true,
                view: 'start'
            }, () => {
                if (this.props.onUpdate) {
                    this.props.onUpdate();
                }
                setTimeout(() => {
                    this.setState({
                        isFinished: true
                    });
                }, 50);
            });

        } else {
            this.setState({
                isLoading: false
            });
        }
    }

    async delete(id) {
        this.setState({
            isLoading: true
        });
        
        const headers = await this.getTokenHeaders();

        const path = this.props.isDistrictEdit ? `${REACT_APP_API_BASE}/salesdistrict/delete/${id}` : 
                                                 `${REACT_APP_API_BASE}/salesdistrict/classification/delete/${id}`;

        const rawResponse = await fetch(path, {
            method: 'DELETE',
            headers: headers
        });

        if (rawResponse.ok) {
            await rawResponse.json();

            this.setState({
                isLoading: false,
                isUpdated: true,
                view: 'start'
            }, () => {
                if (this.props.onUpdate) {
                    this.props.onUpdate();
                }
                setTimeout(() => {
                    this.setState({
                        isFinished: true
                    });
                }, 50);
            });
        } else {
            this.setState({
                isLoading: false
            });
        }
    }

    changeView(view) {
        this.setState({
            view
        });
    }

    toggleEditModal() {

        if (this.state.isUpdated) {
            if (this.props.onCloseAfterUpdate) {
                this.props.onCloseAfterUpdate();
                this.setState({
                    editModalIsOpen: false,
                    isUpdated: false,
                    isFinished: false,
                    view: 'start'
                });
                return;
            }
            window.location.href = `${this.props.listUrl}/${this.props.scenarioId && this.props.scenarioId > 0 ? this.props.scenarioId : '' }`;
        } else {
            this.setState({
                editModalIsOpen: !this.state.editModalIsOpen,
                view: 'start'
            });
        }
    }

    getHeader() {
        if (this.state.view === 'delete') {
            return this.props.deleteHeading;
        }

        if (this.state.view === 'name') {
            return 'Ändra namn';
        }

        if (this.state.isUpdated) {
            return 'Klart!';
        }

        if (this.state.selectScenario) {
            return 'Kopiera till scenario';
        }

        return 'Vad vill du göra?';
    }

    setScenarioView(isView) {
        this.setState({
            selectScenario: isView
        });
    }

    async copyToScenario(districtId, scenarioId) {
        this.setState({
            isLoading: true
        });

        const headers = await this.getTokenHeaders();

        const rawResponse = await fetch(`${REACT_APP_API_BASE}/salesdistrict/copy/${districtId}/toscenario/${scenarioId}`, {
            method: 'POST',
            headers: headers
        });

        if (rawResponse.ok) {
            const result = await rawResponse.json()
            this.setState({
                districtUrl: `${this.props.listUrl}/${scenarioId}`,
                selectScenario: false,
                isLoading: false,
                isUpdated: true,
                isCopied: true,
                view: 'start',
                copyId: result.id
            }, () => {
                if (this.props.onUpdate) {
                    this.props.onUpdate();
                }
                setTimeout(() => {
                    this.setState({
                        isFinished: true
                    });
                }, 50);
            });
        } else {
            this.setState({
                isLoading: false
            });
        }
    }

    async changeName(districtId) {
        this.setState({
            isLoading: true
        });

        const headers = await this.getTokenHeaders();

        const rawResponse = await fetch(`${REACT_APP_API_BASE}/salesdistrict/${districtId}/rename/${encodeURIComponent(this.state.districtName)}`, {
            method: 'PATCH',
            headers: headers
        });

        if (rawResponse.ok) {
    
            this.setState({
                isLoading: false,
                isUpdated: true,
                view: 'start',
                districtUrl: `${this.props.listUrl}/${this.props.scenarioId}`,
                copyId: districtId,
                isCopied: true
            }, () => {
                if (this.props.onUpdate) {
                    this.props.onUpdate();
                }
                setTimeout(() => {
                    this.setState({
                        isFinished: true
                    });
                }, 50);
            });
        } else {
            this.setState({
                isLoading:false,
                editModalIsOpen: false,
            });
        }
    }

    render() {

        return (
            <>
                <button className="districts__edit" type="button" onClick={() => this.toggleEditModal()}></button>
                <Takeover modifiers={{
                    'takeover--no-margin': true
                }} isOpen={this.state.editModalIsOpen} toggleTakeover={() => this.toggleEditModal()} heading={this.getHeader()}>
                    <div className={classNames({
                        'districts__takeover-content': true,
                        'districts__takeover-content--is-loading': this.state.isLoading
                    })}>
                        <nav>
                            {!this.state.isLoading && !this.state.isUpdated && this.state.view === 'start' && !this.state.selectScenario &&
                                <ul className="districts__edit-nav">
                                    {this.props.isDistrictEdit && (
                                        <li>
                                            <button className="districts__edit-nav-btn districts__edit-nav-btn--change-name" onClick={() => this.changeView('name')}>Ändra namn</button>
                                        </li>
                                    )}
                                    <li>
                                        {typeof this.props.renderEditButton === 'function' ? (
                                            this.props.renderEditButton({
                                                closeTakeover: () => this.toggleEditModal(),
                                                className: 'districts__edit-nav-btn districts__edit-nav-btn--edit',
                                                label: this.props.editButton || 'Ändra',
                                                id: this.props.id,
                                                createUrl: this.props.createUrl
                                            })
                                        ) : (
                                            <a
                                                href={`${this.props.createUrl}/${this.props.id}`}
                                                className="districts__edit-nav-btn districts__edit-nav-btn--edit"
                                            >
                                                {this.props.editButton || 'Ändra'}
                                            </a>
                                        )}
                                    </li>
                                    {this.props.isDistrictEdit &&
                                        <>
                                            <li>
                                                <button onClick={() => this.copyDistrict(this.props.id)} className="districts__edit-nav-btn districts__edit-nav-btn--copy" type="button">Skapa kopia</button>
                                            </li>
                                            <li>
                                                <button onClick={() => this.deactivateDistrict(this.props.id, !this.props.isActive)} className={classNames({
                                                    'districts__edit-nav-btn': true,
                                                    'districts__edit-nav-btn--deactivate': this.props.isActive,
                                                    'districts__edit-nav-btn--activate': !this.props.isActive,
                                                })} type="button">{this.props.isActive ? 'Inaktivera' : 'Aktivera'}</button>
                                            </li>
                                            {(this.props.scenarios && this.props.scenarios.length > 1) &&
                                                <li><button onClick={() => this.setScenarioView(true)} className="districts__edit-nav-btn districts__edit-nav-btn--sign" type="button">Kopiera till annat scenario</button></li>
                                            }
                                        </>
                                    }
                                    <li>
                                        <button onClick={() => this.changeView('delete')} className="districts__edit-nav-btn  districts__edit-nav-btn--delete" type="button">Radera</button>
                                    </li>
                                </ul>
                            }                 
                        </nav>

                        {this.state.selectScenario &&
                            <div className="districts__edit-confirm">
                                <label className="districts__destination-lbl" htmlFor="select-destination">
                                    Välj desitnation 
                                </label>
                                <Select id="select-destination" modifiers={{
                                    'districts__destination': true
                                }} onChange={(e) => this.setState({
                                    copyToScenarioId: e.currentTarget.value
                                })} value={this.state.copyToScenarioId}>
                                    <option value="">Välj</option>
                                    {this.props.scenarios && this.props.scenarios.map(scenario => {
                                        if (scenario.salesDistrictScenarioId === this.props.scenarioId) return null;
                                        return (                                            
                                            <option key={scenario.salesDistrictScenarioId} value={scenario.salesDistrictScenarioId}>{scenario.name}</option>
                                        );
                                    })}
                                </Select>
                                
                                <button disabled={!this.state.copyToScenarioId} onClick={() => this.copyToScenario(this.props.id, this.state.copyToScenarioId)} type="button" className="districts__takeover-controls-btn districts__takeover-controls-btn--success">Kopiera</button>
                                <button onClick={() => this.setScenarioView(false)} type="button" className="districts__takeover-controls-btn districts__takeover-controls-btn--outline">Tillbaka</button>
                            </div>
                        }

                        {this.state.view === 'delete' &&
                            <div className="districts__edit-confirm">
                                <p>{this.props.confirmText}</p>
                                <div className="districts__edit-confirm-buttons">
                                    <button onClick={() => this.changeView('start')} type="button" className="districts__takeover-controls-btn districts__takeover-controls-btn--outline">Tillbaka</button>
                                    <button onClick={() => this.delete(this.props.id)} type="button" className="districts__takeover-controls-btn districts__takeover-controls-btn--danger">{this.props.deleteButtonText}</button>
                                </div>
                            </div>
                        }

                        {this.state.view === 'name' &&
                            <div className="districts__edit-confirm">
                                <label className="districts__destination-lbl" htmlFor="district-name">
                                    Namn:
                                </label>
                                <input id="district-name" className="districts__change-name" type="text" value={this.state.districtName} onChange={(e) => this.setState({
                                    districtName: e.currentTarget.value
                                })} />
                                <button onClick={() => this.changeName(this.props.id)} type="button" className="districts__takeover-controls-btn districts__takeover-controls-btn--success">Spara distrikt</button>
                                <button onClick={() => this.changeView('start')} type="button" className="districts__takeover-controls-btn districts__takeover-controls-btn--outline">Tillbaka</button>
                            </div>
                        }

                        {this.state.isUpdated &&
                            <>
                                <div className={classNames({
                                    'districts__takeover-success': true,
                                    'districts__takeover-success--is-finished': this.state.isFinished
                                })}>
                                    <Success isFinished={this.state.isFinished} />
                                    <div className="districts__takeover-controls">
                                        {this.state.isCopied &&
                                            <a href={`${this.state.districtUrl}/district/${this.state.copyId}`} className="districts__takeover-controls-btn districts__takeover-controls-btn--success">
                                                <span>Visa säljdistriktet</span>
                                            </a>
                                        }
                                        <button onClick={() => this.toggleEditModal()} className="districts__takeover-controls-btn districts__takeover-controls-btn--outline" type="button">Stäng</button>
                                    </div>
                                </div>
                            </>
                        }
                        <SpinnerDots />
                    </div>
                </Takeover>
            </>
        );
    }
};

export default withAuthProvider(withFetch(EditTakeover));